const PDF_MIME_TYPE = 'application/pdf'
const OBJECT_URL_REVOKE_DELAY = 60000

const isBlob = (value) => typeof Blob !== 'undefined' && value instanceof Blob

const toPdfBlob = (source) => {
    if (isBlob(source)) {
        return source.type === PDF_MIME_TYPE ? source : new Blob([source], { type: PDF_MIME_TYPE })
    }

    return new Blob([source], { type: PDF_MIME_TYPE })
}

const revokeObjectUrlLater = (url) => {
    window.setTimeout(() => window.URL.revokeObjectURL(url), OBJECT_URL_REVOKE_DELAY)
}

const triggerDownload = (url, filename) => {
    const link = document.createElement('a')
    link.href = url
    link.download = filename || 'documento.pdf'
    link.rel = 'noopener noreferrer'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export const openPdfBlob = ({ data, filename, targetWindow }) => {
    const blob = toPdfBlob(data)
    const objectUrl = window.URL.createObjectURL(blob)

    let opened = false

    if (targetWindow && !targetWindow.closed) {
        try {
            targetWindow.location = objectUrl
            opened = true
        } catch (error) {
            opened = false
        }
    }

    if (!opened) {
        try {
            const newWindow = window.open(objectUrl, '_blank', 'noopener,noreferrer')
            opened = Boolean(newWindow)
        } catch (error) {
            opened = false
        }
    }

    if (!opened) {
        if (targetWindow && !targetWindow.closed) {
            targetWindow.close()
        }
        triggerDownload(objectUrl, filename)
    }

    revokeObjectUrlLater(objectUrl)
}

const parseTextAsMessage = (text) => {
    if (!text) {
        return ''
    }

    try {
        const parsed = JSON.parse(text)

        if (typeof parsed === 'string') {
            return parsed
        }

        return parsed.msg || parsed.message || parsed.error || text
    } catch (error) {
        return text
    }
}

export const extractBlobErrorMessage = async (error, fallbackMessage) => {
    const responseData = error?.response?.data

    if (isBlob(responseData)) {
        const text = await responseData.text()
        const parsedMessage = parseTextAsMessage(text)

        if (parsedMessage) {
            return parsedMessage
        }
    }

    if (typeof responseData === 'string' && responseData) {
        return responseData
    }

    if (error?.response?.data?.msg) {
        return error.response.data.msg
    }

    return error?.message || fallbackMessage
}

export const ensurePdfResponse = async (response, fallbackMessage) => {
    const contentType = response?.headers?.['content-type'] || ''

    if (contentType.toLowerCase().includes(PDF_MIME_TYPE)) {
        return response.data
    }

    const message = await extractBlobErrorMessage({ response }, fallbackMessage)
    throw new Error(message || fallbackMessage)
}
